import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { BaseController } from '@common/modules/base/';

export interface Paginator {
  length: number;
  pageSize: number;
  pageIndex: number;
  pageSizeOptions: number[];
}

@Component({
  selector: 'app-base-listagem',
  template: '',
  styles: [],
})
export class BaseListagemComponent<T> implements OnInit {
  public paginationOptions = {
    length: 0,
    pageSize: 10,
    pageIndex: 0,
    pageSizeOptions: [5, 10, 25],
  }

  public items: T[] = [];
  protected currentSearchQuery: string = '';

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  constructor(@Inject('title') title: string, private controller: BaseController<T>) {
    window.document.title = title;
  }

  ngOnInit(): void {
    this.paginator.page.subscribe((value) => {
      this.paginationOptions.pageIndex = value.pageIndex;
      this.paginationOptions.pageSize = value.pageSize;
      this.filtrar();
    });

    this.paginator._intl.itemsPerPageLabel = 'Itens por página';
    this.filtrar();
  }

  public filtrar(search?: string) {
    if(search !== undefined) {
      this.paginationOptions.pageIndex = 0;
      this.paginator.pageIndex = 0;
      this.currentSearchQuery = search;
    }

    const params = {
      search: this.currentSearchQuery,
      page: this.paginationOptions.pageIndex + 1,
      offset: this.paginationOptions.pageSize * this.paginationOptions.pageIndex,
      limit: this.paginationOptions.pageSize,
    }

    this.controller.getPaginated(params).subscribe(({ data }) => {
      this.paginationOptions.length = data.count;
      this.items = data.results;
    });
  }
}
